import countries from '../views/Movies/countries.json';

// ISO 3166-1 alpha-2 code to display name, falling back to the raw code so an
// unknown or legacy value still shows something meaningful.
export const countryName = code => countries.regions.find(country => country.code === code)?.name || code;
